var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 24.2414,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_771_8301",
    transform: "translate(0 0.108108) scale(0.0208333 0.0163288)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_771_8301",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAepJREFUaEPtmD1Ow0AQhd9Y0FJREQIlEnFAHIOenwYJbgEXQIICTsGPchoQOPQk4QD0JIMW2ZKxvB57N0MStK4irXfme/NmZ5MQFvyhBedHEDBrB4MDc+/AKCbOQ64nPFeuiTBBgHKPBQeUC4z3bXQ239C35ZlrB0ZdHILpgZhuWv3JRZmIuRWQwQNYMuDEdF0m4k8EfMQ4NhCtBL06LWfeZ9BdBp/u+ZpEvLfxgiQfQ11ArpLE4LN2AgNmfYqVT18cM/Fp+xX3xY2qAkpgxlUimsL/tJZkqetFZoEx6UpFuMCrCaiAz+r1S4QrvIoA2wFMyX8mSnYoCXxiPpcdWLNW59BPtYVs8FWgNmF14KfqQJ02GHVwAKLHwnjMH0PrtFG9ievAZwAVIhrDT8WBJvAVIpzgvQW4wJeIINslJY14LwGDHcTRhJ6K133d6WGSN/2KUSbIawoNuzgnpivpuq9TSdd3vASYpKmIS582cIX3aqF8UulHhw+gtNfbASmB9noQoF1hKX5wQKqQ9npwQLvCUvz/78Awpk8CVqRKaK/b/hWv4UDUA/hIG1CK7yxguIsWjekZwKqURHPdWYCBGmxhLVqObhm8P6t28hKgWVnf2OIZ8E2gvT8I0K6wFD84IFVIez04oF1hKf43SphWQMU6qj0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.b94aff53ca270f27e3e59f640197c976.svg";
export { ForwardRef as ReactComponent };